// =============================================================================
// src/views/workspace/workspace-navigate.ts — "Abrir análise" (restauração A2).
//
// Restaura o estado mockado de uma análise: fecha a rota Workspace, navega para a
//   seção-destino (SectionManager.activateSection) e, se houver zona capturada,
//   refoca o mapa (MapController.focusZone). Ano/camada são rótulos descritivos —
//   não há API para restaurá-los (controllers travados por paridade).
//
// SRP: só a ação de abrir/navegar. Sem markup, sem store.
// =============================================================================

import type { AppContext } from '../../app/types';
import type { WorkspaceAnalysis } from './workspace-types';
import { SectionManager } from '../../core/section-manager';
import { WorkspaceRoute } from './workspace-route';

/** Fecha o Workspace e restaura seção + região da análise; toast de confirmação. */
export function openAnalysisInMap(analysis: WorkspaceAnalysis, ctx: AppContext): void {
  WorkspaceRoute.close();
  SectionManager.activateSection(analysis.targetSection);
  if (analysis.zona) ctx.map?.focusZone(analysis.zona);
  ctx.commands.sendPrompt(`Abrindo "${analysis.title}"`);
}
